window.datalayer_view_item_list = {};
window.datalayer_items = {};
window.datalayer_cart_item_list = [];
window.datalayer_cart_items = {};

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".smartwishlist").forEach((target) => {
    target.addEventListener("mousedown", () => {
      let event_name = target.classList.contains("unbookmarked")
        ? "add_to_wishlist"
        : "remove_from_wishlist";

      let product_datalayer =
        datalayer_items[target.getAttribute("data-variant")];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: event_name,
        ecommerce: {
          value: product_datalayer["price"],
          currency: product_datalayer["currency"],
          items: [product_datalayer],
        },
        user: window.datalayer_user,
      });
    });
  });

  if (window.datalayer_view_item_list) {
    Object.keys(window.datalayer_view_item_list).forEach((key) => {
      if (window.datalayer_view_item_list[key]["items"].length > 0) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            item_list_id: key,
            item_list_name: window.datalayer_view_item_list[key]["name"],
            items: window.datalayer_view_item_list[key]["items"].map(
              (item, i) => {
                item["index"] = i;
                return item;
              }
            ),
          },
          user: window.datalayer_user,
        });
      }
    });
  }

  let form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (form) {
    form.addEventListener("submit", () => {
      event.preventDefault();

      let variant_id = form.querySelector("input.product-variant-id").value;
      let quantityInput = form.querySelector('input[name="quantity"]');
      let quantity = quantityInput ? parseInt(quantityInput.value) : 1; // Ottieni la quantità dal form, default a 1

      let product_datalayer = datalayer_items[variant_id];
      if (!product_datalayer) {
        console.error(
          "product_datalayer è undefined per variant_id:",
          variant_id
        );
        return;
      }

      product_datalayer["quantity"] = quantity;
      const num_items = quantity;

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          value: product_datalayer["price"],
          currency: product_datalayer["currency"],
          num_items: num_items,
          items: [product_datalayer],
        },
        user: window.datalayer_user,
      });
    });
  }

  document.body.addEventListener("click", function (event) {
    // Controlla se l'elemento cliccato (o uno dei suoi antenati) ha la classe 'slam-product-link'
    var target = event.target;
    while (target && target !== this) {
      if (target.matches(".slam-product-link")) {
        let variant_id = target.getAttribute("data-variant-id");
        let product_datalayer = datalayer_items[variant_id];
        let collection_handle = target.getAttribute("data-collection-handle");

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "select_item",
          ecommerce: {
            item_list_id: collection_handle || "",
            item_list_name: collection_handle
              ? window.datalayer_view_item_list[collection_handle]["name"]
              : "",
            items: [product_datalayer],
          },
          user: window.datalayer_user,
        });

        return; // Esce dalla funzione
      }
      target = target.parentNode;
    }
  });

  let loginForm = document.querySelector("#customer_login");
  if (loginForm) {
    loginForm.addEventListener("submit", () => {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "login",
      });
    });
  }

  let signupForm = document.querySelector("#create_customer");
  if (signupForm) {
    signupForm.addEventListener("submit", () => {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "sign_up",
      });
    });
  }

  let sectionFormProstore = document.querySelector("#section_form_prostore");
  if (sectionFormProstore) {
    sectionFormProstore.querySelector("form").addEventListener("submit", () => {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "sign_up_pro",
      });
    });
  }

  document.addEventListener(
    "submit",
    function (event) {
      // Controlla se l'elemento che ha innescato l'evento è una form
      if (event.target.tagName === "FORM") {
        if (event.target.id.toString().indexOf("omnisend-form-") > -1) {
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "newsletter_sign_up",
          });
        }
      }
    },
    true
  );

  window.setTimeout(function () {
    const targetForm = document.querySelector('form[data-id="67912"]');

    if (targetForm) {
      // Aggiungi un listener per l'evento "submit"
      targetForm.addEventListener("submit", function (event) {
        // Invia l'evento a Google Analytics 4
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "sign_up",
        });
      });
    } else {
      console.warn("Private Sale Form not found");
    }
  }, 2500);
});
